module.exports = __webpack_public_path__ + "img/homes_jigu.1e35ff89.svg";